import { Tag } from 'antd';
import React   from 'react';

export const ResultComment = ({ value, record }) => {
  return !!value ? <Tag color="blue">Ja</Tag> : <Tag color="orange">Nein</Tag>;
};
